import { create } from "zustand";

const useInitialDataStore = create((set) => ({
  initialLoaded: false,
  initialData: null,

  setInitialData: (data) =>
    set({
      initialData: data,
      initialLoaded: true,
    }),
}));

export default useInitialDataStore;
